import type {
  CertificateCheckInfo,
  CertificateCheckInfoList,
} from '@/api/models/medcomplex'

export const prepareNotifications = (data: CertificateCheckInfo[]) => {
  const pastNotifications = JSON.parse(
    localStorage.getItem('past_notifications') ?? '[]'
  )
  const skipNotifications = JSON.parse(
    localStorage.getItem('skip_notifications') ?? '[]'
  )

  const validNotifications = data?.filter(
    (newNotification) =>
      !skipNotifications.find(
        (skipNotification: CertificateCheckInfo) =>
          skipNotification?.id === newNotification?.id
      )
  )
  const newNotifications = validNotifications?.filter(
    (validNotification) =>
      !pastNotifications.find(
        (pastNotification: CertificateCheckInfo) =>
          pastNotification?.id === validNotification.id
      )
  )
  const pastValidNotifications = validNotifications?.filter(
    (validNotification) =>
      !newNotifications.find(
        (newNotification) => newNotification?.id === validNotification?.id
      )
  )

  const newPastNotifications = pastNotifications.filter(
    (pastNotification: CertificateCheckInfo) =>
      data.find((item) => pastNotification?.id === item?.id)
  )
  const newSkipNotifications = skipNotifications.filter(
    (skipNotification: CertificateCheckInfo) =>
      data.find((item) => skipNotification?.id === item?.id)
  )

  localStorage.setItem(
    'past_notifications',
    JSON.stringify([...newPastNotifications])
  )
  localStorage.setItem(
    'skip_notifications',
    JSON.stringify([...newSkipNotifications])
  )

  return {
    notifications: (newNotifications ?? []).concat(
      pastValidNotifications ?? []
    ),
    notificationQueue: newNotifications ?? [],
  }
}
